import { CircleDollarSign } from "lucide-react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import type { BudgetPlanNode } from "../lib/build-budget-plan";

import { BudgetSankeyChart } from "./budget-sankey";

export function BudgetFlowCard({
  loading,
  nodes,
  links,
  currencyCode,
  onBookNodeClick,
}: {
  loading: boolean;
  nodes: BudgetPlanNode[];
  links: { source: number; target: number; value: number }[];
  currencyCode: string;
  onBookNodeClick: (payload: { id?: string }) => void;
}) {
  const hasData = nodes.length > 0 && links.length > 0;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Budget Flow</CardTitle>
        <CardDescription>
          Visualize how your income gets distributed to your expenses and
          portfolios.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="flex h-[600px] items-center justify-center text-sm text-muted-foreground">
            Loading budget flow...
          </div>
        ) : hasData ? (
          <BudgetSankeyChart
            data={{ nodes, links }}
            currencyCode={currencyCode}
            onBookNodeClick={onBookNodeClick}
          />
        ) : (
          <div className="flex h-[400px] flex-col items-center justify-center gap-2 text-sm text-muted-foreground">
            <CircleDollarSign className="h-8 w-8 text-muted-foreground/50" />
            <p>Add at least one enabled income item to see the flow chart.</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
